import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: "My 5-year-old now tells me when she's feeling frustrated instead of throwing things. This kit changed our evenings completely.",
  name: 'Sarah M.',
  role: 'Mom of two'
}, {
  quote: "I use these cards in my classroom every morning. The kids love the games and I've seen a real difference in how they treat each other.",
  name: 'James T.',
  role: '2nd Grade Teacher'
}, {
  quote: 'As a child therapist, I recommend this to every family I work with. It makes emotional conversations accessible and fun.',
  name: 'Dr. Lisa Chen',
  role: 'Child Psychologist'
}, {
  quote: "We were skeptical about a printable kit, but our son asks to play the emotion games every day. Best $15 we've spent.",
  name: 'Mark & Anna R.',
  role: 'Parents'
}, {
  quote: 'The calming exercises have been a game-changer for my daughter with anxiety. She uses them on her own now.',
  name: 'Rachel K.',
  role: 'Mom'
}, {
  quote: "Finally something that doesn't involve a screen! My kids are learning empathy through actual play.",
  name: 'David P.',
  role: 'Dad of three'
}];
export function Testimonials() {
  return <section id="reviews" className="py-24 bg-cream relative" data-id="element-267">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-268">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-269">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-dark mb-6" data-id="element-270">
            Loved by Families Around the World
          </h2>
          <div className="flex justify-center items-center gap-2 text-accent mb-4" data-id="element-271">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" data-id="element-272" />)}
          </div>
          <p className="text-xl text-muted" data-id="element-273">
            Over 2,000 happy parents, teachers, and therapists.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-274">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-275">
              <div className="flex text-accent mb-4" data-id="element-276">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-277" />)}
              </div>
              <p className="text-dark font-medium text-lg leading-relaxed mb-6 flex-grow" data-id="element-278">
                "{testimonial.quote}"
              </p>
              <div data-id="element-279">
                <p className="font-heading font-bold text-dark" data-id="element-280">
                  {testimonial.name}
                </p>
                <p className="text-sm text-muted" data-id="element-281">{testimonial.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}